import React, { useEffect } from "react";
import { FILEHISTORYINFO } from "../../App.config";
import * as utilities from "../../utilities/utils";
import moment from "moment";

const FileUploadHistoryDetailComponent = (props) => {
  useEffect(() => {
    props.getFileHistory(props.fileLevel);
  }, []);

  useEffect(() => {
    return () => {
      props.resetFileHistory();
    };
  }, []);

  return (
    <div className="modal-dialog modal-dialog-centered" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title" id="exampleModalLabel">
            {FILEHISTORYINFO}
          </h5>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={() => props.closeRemoveModal()}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          {/* <span> */}
          <table class="table mt-2">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">{props.context.t("Attachment.FileName.Text")}</th>
                <th scope="col">Uploaded By</th>
                <th scope="col">Created Date</th>
              </tr>
            </thead>
            {Array.isArray(props.fileHistoryDetails) &&
              props.fileHistoryDetails.length
              ? props.fileHistoryDetails.map((fileHistory,i) => (
                <tbody>
                   {/* {Array.isArray(props.fileHistoryDetails) &&
              props.fileHistoryDetails.length
              && props.fileHistoryDetails.map((fileHistory) => {
                    return ( */}
                      <tr>
                        <th scope="row">{i + 1}</th>
                        <td><a title={fileHistory.FileName}>{fileHistory.FileName.length <= 10 ? fileHistory.FileName : fileHistory.FileName.slice(0, 10) + "..."}</a></td>
                        <td><a title={fileHistory.FirstName + " " + fileHistory.LastName}>{(fileHistory.FirstName.length + 1 + fileHistory.LastName.length) <= 10 ? fileHistory.FirstName + " " + fileHistory.LastName : fileHistory.FirstName + " " + fileHistory.LastName + "..."}</a></td>
                        <td><a title={moment(fileHistory.CreatedOnDate).format("MM/DD/yyyy")}>{moment(fileHistory.CreatedOnDate).format("MM/DD/yyyy")}</a></td>
                      </tr>
                    {/* ) */}

                  {/* })} */}
                </tbody>
              ))
              : null}
            {/* </span> */}
          </table>
        </div>
      </div>
    </div>
  );
};
export default FileUploadHistoryDetailComponent;
